// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETE_MODERATOR = "Nechci moderovat";
